export enum TABLE_COLUMN_TYPE_ENUM {
    COLUMN_WITH_CHECKBOX = 'column_with_checkbox',
    NON_EDITABLE_COLUMN = 'non_editable_column',
    NON_EDITABLE_COLUMN_WITH_IMAGE = 'non-editable_column_with_image',
    COLUMN_WITH_DISABLE_TOGGLE_SWITCH = 'column_with_disable_toggle_switch',
    COLUMN_WITH_ENABLE_TOGGLE_SWITCH = 'column_with_enable_toggle_switch',
    COLUMN_WITH_CHIP = 'column_with_chip',
    ACTIONS_WITH_OPERATIONS = 'action_operations_type',
    ICON = 'icon',
    ICON_WITH_ENABLED_DISABLED_STATUS = 'icon_with_enable_disabled_status',
    COLUMN_CHECKBOX_WITH_IMAGE = 'column_checkbox_with_image',
    HTML_CONTENT_VIEWER = 'html_content_viewer',
    CONVERT_EPOCH_TO_DATE = 'convert_epoch_to_date',
}

// Below enum are used to set the constant property which we are not getting for the backend and setting it in the backed
// Example in the table column with icon we don't get which icon we have to show in that column we set that property with the icon path in the api response json for that we write logic in the corresponding component
export enum RUNTIME_TABLE_COLUMN_PROPRTY {
    COLUMN_WITH_ICON = 'column_icon_path',
}
